import { render, staticRenderFns } from "./radioSamootchetMismatch.vue?vue&type=template&id=1b9a2839"
import script from "./radioSamootchetMismatch.vue?vue&type=script&lang=js"
export * from "./radioSamootchetMismatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports